import { jsPDF } from 'jspdf';
import { formatCurrency } from './calculations';

export const generatePDF = (data) => {
  const { 
    name, 
    grossPrice, 
    spaPrice, 
    isBumi, 
    bumiPercentage,
    rebates, 
    cashbacks,
    totalRebate, 
    totalCashback, 
    nettPrice, 
    nettDownPayment,
    dpPercentage,
    formulaString 
  } = data;

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  const contentWidth = pageWidth - (2 * margin);
  let yPos = 20;

  // Header
  doc.setFillColor(16, 185, 129);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('RebatePro', margin, 20);
  
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text('Property Rebate Calculation Report', margin, 28);

  yPos = 50;

  // Project Name
  if (name) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text(name, margin, yPos);
    yPos += 12;
  }

  // Date
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(128, 128, 128);
  const dateStr = new Date().toLocaleDateString('en-MY', { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric' 
  });
  doc.text(`Generated: ${dateStr}`, margin, yPos);
  yPos += 15;

  // Property Details Section
  doc.setFillColor(245, 245, 245);
  doc.rect(margin, yPos, contentWidth, 8, 'F');
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('PROPERTY DETAILS', margin + 3, yPos + 5.5);
  yPos += 15;

  // Gross Price
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Gross Price:', margin + 5, yPos);
  doc.setFont('helvetica', 'bold');
  doc.text(formatCurrency(grossPrice), pageWidth - margin - 5, yPos, { align: 'right' });
  yPos += 8;

  // Bumi Discount
  if (isBumi) {
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(16, 185, 129);
    doc.text(`Bumi Discount (${bumiPercentage || 7}%):`, margin + 5, yPos);
    doc.setFont('helvetica', 'bold');
    doc.text(`-${formatCurrency(grossPrice - spaPrice)}`, pageWidth - margin - 5, yPos, { align: 'right' });
    yPos += 8;
  }

  // SPA Price
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('SPA Price:', margin + 5, yPos);
  doc.text(formatCurrency(spaPrice), pageWidth - margin - 5, yPos, { align: 'right' });
  yPos += 12;

  // Formula
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80, 80, 80);
  doc.text(`Formula Applied: ${formulaString}`, margin + 5, yPos);
  yPos += 12;

  // Rebates Section
  if (rebates && rebates.length > 0) {
    doc.setFillColor(245, 245, 245);
    doc.rect(margin, yPos, contentWidth, 8, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('REBATES', margin + 3, yPos + 5.5);
    yPos += 13;

    rebates.forEach((rebate) => {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(16, 185, 129);
      doc.text(`${rebate.percentage}%`, margin + 5, yPos);
      doc.setFont('helvetica', 'bold');
      doc.text(`-${formatCurrency(rebate.amount)}`, pageWidth - margin - 5, yPos, { align: 'right' });
      yPos += 7;
    });

    doc.setFont('helvetica', 'bold');
    doc.text('Total Rebates:', margin + 5, yPos);
    doc.text(`-${formatCurrency(totalRebate)}`, pageWidth - margin - 5, yPos, { align: 'right' });
    yPos += 12;
  }

  // Cashback Section
  if (cashbacks && cashbacks.length > 0) {
    doc.setFillColor(245, 245, 245);
    doc.rect(margin, yPos, contentWidth, 8, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('CASHBACK', margin + 3, yPos + 5.5);
    yPos += 13;

    cashbacks.forEach((cashback) => {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(16, 185, 129);
      doc.text('Flat Amount', margin + 5, yPos);
      doc.setFont('helvetica', 'bold');
      doc.text(`-${formatCurrency(cashback)}`, pageWidth - margin - 5, yPos, { align: 'right' });
      yPos += 7;
    });

    doc.setFont('helvetica', 'bold');
    doc.text('Total Cashback:', margin + 5, yPos);
    doc.text(`-${formatCurrency(totalCashback)}`, pageWidth - margin - 5, yPos, { align: 'right' });
    yPos += 12;
  }

  // Final Nett Price
  doc.setFillColor(240, 240, 240);
  doc.rect(margin, yPos, contentWidth, 15, 'F');
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('FINAL NETT PRICE', margin + 3, yPos + 10);
  doc.setFontSize(16);
  doc.text(formatCurrency(nettPrice), pageWidth - margin - 3, yPos + 10, { align: 'right' });
  yPos += 22;

  // Down Payment Section
  if (nettDownPayment !== null && nettDownPayment !== undefined) {
    const isPositive = nettDownPayment >= 0;
    const label = isPositive ? 'ACTUAL CASH UPFRONT' : 'CASHBACK TO BUYER';
    const color = isPositive ? [255, 149, 0] : [16, 185, 129];

    doc.setFillColor(...color, 0.1);
    doc.rect(margin, yPos, contentWidth, 18, 'F');
    
    doc.setDrawColor(...color);
    doc.setLineWidth(0.5);
    doc.rect(margin, yPos, contentWidth, 18);

    doc.setTextColor(...color);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${label} (${dpPercentage || 10}% DP)`, margin + 3, yPos + 7);
    
    doc.setFontSize(16);
    doc.text(formatCurrency(Math.abs(nettDownPayment)), pageWidth - margin - 3, yPos + 7, { align: 'right' });
    
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`= (SPA × ${dpPercentage || 10}%) - Rebates - Cashback`, margin + 3, yPos + 14);
    yPos += 25;
  }

  // Footer
  const footerY = doc.internal.pageSize.getHeight() - 15;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(150, 150, 150);
  doc.text('Calculated with RebatePro - Professional Property Rebate Calculator', pageWidth / 2, footerY, { align: 'center' });
  doc.text(`www.rebatepro.com | Generated on ${dateStr}`, pageWidth / 2, footerY + 4, { align: 'center' });

  return doc;
};

export const downloadPDF = (data, filename = 'rebate-calculation.pdf') => {
  const doc = generatePDF(data);
  doc.save(filename);
};

export const sharePDF = async (data, filename = 'rebate-calculation.pdf') => {
  const doc = generatePDF(data);
  const pdfBlob = doc.output('blob');
  
  if (navigator.share && navigator.canShare({ files: [new File([pdfBlob], filename, { type: 'application/pdf' })] })) {
    try {
      const file = new File([pdfBlob], filename, { type: 'application/pdf' });
      await navigator.share({
        files: [file],
        title: 'RebatePro Calculation',
        text: 'Property rebate calculation report'
      });
      return { success: true, method: 'native' };
    } catch (error) {
      if (error.name === 'AbortError') {
        return { success: false, error: 'Share cancelled' };
      }
      // Fallback to download
      doc.save(filename);
      return { success: true, method: 'download' };
    }
  } else {
    // Fallback to download
    doc.save(filename);
    return { success: true, method: 'download' };
  }
};
